<template>
  <div>
    <vetster-location-search
      :locale="locale"
      :countries="countries"
      class="py-6 px-standard"
      @location-selected="handleLocationSelected"
    />

    <vetster-search-day-picker
      show-next-available-button
      class="py-6 border-t-4 border-neutral-200"
    />

    <vetster-show-client-pets
      v-if="hasUser && isClient && hasPets"
      class="pt-6 pb-3 px-standard border-t-4 border-neutral-200"
    />
    <vetster-show-pet-species
      v-else
      class="py-6 px-standard border-t-4 border-neutral-200"
    />

    <vetster-show-pet-concerns class="py-6 px-standard border-t-4 border-neutral-200" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterLocationSearch from '@/brand-components/GuidedSearch/VetsterLocationSearch';
import VetsterSearchDayPicker from '@/brand-components/GuidedSearch/VetsterSearchDayPicker';
import VetsterShowPetConcerns from '@/brand-components/GuidedSearch/VetsterShowPetConcerns';
import VetsterShowPetSpecies from '@/brand-components/GuidedSearch/VetsterShowPetSpecies';
import VetsterShowClientPets from '@/brand-components/VetsterShowClientPets';

export default {
  name: 'VetsterSearchFilters',

  components: {
    VetsterLocationSearch,
    VetsterSearchDayPicker,
    VetsterShowPetConcerns,
    VetsterShowPetSpecies,
    VetsterShowClientPets,
  },

  props: {
    countries: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters([
      'hasUser',
      'isClient',
    ]),
    ...mapGetters('search', ['getInputs']),
    ...mapGetters('pets', ['hasPets']),
  },

  methods: {
    handleLocationSelected(data) {
      this.$emit('location-selected', data);
    },
  },
};
</script>
